import { render, staticRenderFns } from "./ClientsToolbar.vue?vue&type=template&id=0ec0f931&"
import script from "./ClientsToolbar.vue?vue&type=script&lang=js&"
export * from "./ClientsToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientsToolbar.vue"
export default component.exports